import type { StravaStatus } from '@painpal/contracts';
import { formatRelative } from '../lib/format';
import { importCounts, needsReconnect } from '../lib/strava';

export function initials(name: string): string {
  const letters = name.trim().split(/\s+/).filter((word) => word !== '').slice(0, 2).map((word) => word.charAt(0).toUpperCase()).join('');
  return letters === '' ? '?' : letters;
}

export interface SyncPill { tone: 'green' | 'amber' | 'hot'; text: string }

export function syncPill(strava: StravaStatus | undefined, now: Date): SyncPill | null {
  if (strava === undefined) return null;
  // A revoked or unreadable link is never connected, so it is checked first.
  if (needsReconnect(strava)) return { tone: 'hot', text: 'RECONNECT' };
  if (!strava.connected) return null;
  const backfill = strava.backfill;
  if (backfill !== null && backfill.status === 'running') return { tone: 'amber', text: `IMPORTING ${importCounts(backfill, '/')}` };
  if (strava.lastSyncAt === null) return { tone: 'green', text: 'CONNECTED' };
  return { tone: 'green', text: `SYNCED ${formatRelative(strava.lastSyncAt, now)}` };
}

// Strava's brand guidelines: pages showing Strava data say so. Settings shows the link itself, not the data.
export function showsStravaAttribution(pathname: string, strava: StravaStatus | undefined): boolean {
  if (strava === undefined || pathname === '/settings') return false;
  return strava.status === 'active' || strava.activities > 0;
}
